import React from 'react';
import ContentLoader from 'react-content-loader';
var ItemSkeletonLap = function ItemSkeletonLap() {
  var skeletons = [];
  for (var index = 0; index < 12; index++) {
    skeletons.push(/*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(ContentLoader, {
      speed: 1,
      width: '100%',
      height: 328,
      viewBox: "0 0 auto 310",
      backgroundColor: "#f3f3f3",
      foregroundColor: "#ecebeb",
      style: {
        background: 'white',
        marginTop: '20px'
      }
    }, /*#__PURE__*/React.createElement("rect", {
      x: "24",
      y: "16",
      rx: "3",
      ry: "3",
      width: "127",
      height: "48"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "80",
      rx: "3",
      ry: "3",
      width: "95%",
      height: "8"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "100",
      cy: "186",
      r: "64"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "208",
      y: "150",
      rx: "3",
      ry: "3",
      width: "150",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "208",
      y: "180",
      rx: "3",
      ry: "3",
      width: "120",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "400",
      y: "150",
      rx: "3",
      ry: "3",
      width: "250",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "400",
      y: "180",
      rx: "3",
      ry: "3",
      width: "206",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "481",
      y: "373",
      rx: "0",
      ry: "0",
      width: "1",
      height: "0"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "400",
      y: "216",
      rx: "3",
      ry: "3",
      width: "30",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "400",
      y: "236",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "400",
      y: "260",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "508",
      y: "216",
      rx: "3",
      ry: "3",
      width: "30",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "508",
      y: "236",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "508",
      y: "260",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, skeletons);
};
export default ItemSkeletonLap;